import { FormValues, IFilter, StringOptions, NumberOptions, BooleanOptions } from "../../types";
import {
  formatDate,
  formatDateFilter,
} from "../../../../../utils/generalFormat";
import { Button, Col, Container, Label } from "../../styles";
import { Row } from "antd";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import Select from "antd/lib/select";

export const FormFilter: React.FC<IFilter> = (props: IFilter) => {
  const { getFilters, userType } = props;
  const [paymentTypeFieldValue, setPaymentTypeFieldValue] = useState("");
  const [statusTypeFieldValue, setStatusPaymentTypeFieldValue] = useState(null);
  const [brandCodeFieldValue, setBrandCodeFieldValue] = useState("");
  const [receiverTypeFieldValue, setReceiverTypeFieldValue] = useState<number | null>(null);
  const [sftpEnabledFieldValue, setSftpEnabledFieldValue] = useState<boolean | null>(null);

  const getInitialValues = (): FormValues => {
    const date = new Date();
    date.setHours(0, 0, 0, 1);
    const startDate = formatDate(date);
    date.setHours(23, 59, 59, 59);
    const finishDate = formatDate(date);
    return {
      merchantId: "",
      rangeStartReceiveDate: startDate,
      rangeEndReceiveDate: finishDate,
      paymentType: "",
      paymentIdentifier: "",
      operationStatus: null,
      receiverType: "",
      sftpEnabled: null,
      isAdmin: userType === 3 ? true : false,
    };
  };

  const handleChangeInitialDate = (
    event: React.ChangeEvent<HTMLInputElement>,
    setFieldValue: (field: string, value: any) => void
  ) => {
    const { value } = event.target;
    const date = new Date(value);
    setFieldValue("rangeStartReceiveDate", date);
  };

  const handleChangeEndDate = (
    event: React.ChangeEvent<HTMLInputElement>,
    setFieldValue: (field: string, value: any) => void
  ) => {
    const { value } = event.target;
    const date = new Date(value + "T23:59:59Z");
    setFieldValue("rangeEndReceiveDate", date);
  };

  const getSettlementReceivables = async (submit: any) => {
    if (submit.startDate === "") {
      const date = new Date();
      date.setHours(0, 0, 0, 0);
      submit.startDate = formatDateFilter(date);
    } else {
      const formattedDateStart = formatDateFilter(submit.startDate);
      submit.startDate = formattedDateStart;
    }

    if (submit.finishDate === "") {
      const tomorrow = new Date();
      tomorrow.setHours(23, 59, 59, 0);
      submit.finishDate = formatDateFilter(tomorrow);
    } else {
      const formattedDateFinish = formatDateFilter(submit.finishDate);
      submit.finishDate = formattedDateFinish;
    }

    getFilters(submit);
    return submit;
  };

  const paymentOptions: StringOptions[] = [
    { label: "Tipo Pagamento", value: "" },
    { label: "Débito", value: "D" },
    { label: "Crédito Antecipado", value: "A" },
    { label: "Crédito não Antecipado", value: "C" },
  ];

  const statusOptions: BooleanOptions[] = [
    { label: "Status", value: null },
    { label: "Sucesso", value: true },
    { label: "Falha", value: false },
  ];

  const receiverTypeOptions: NumberOptions[] = [
  { label: "Tipo Recebedor", value: null },
  { label: "Credor", value: 1 },
  { label: "Merchant", value: 2 },
  { label: "Split", value: 4 },
];

  const sftpEnabledOptions: BooleanOptions[] = [
    { label: "Enviado para SFTP", value: null },
    { label: "Sim", value: true },
    { label: "Não", value: false },
  ];

  const brandCodeOptions: StringOptions[] = [
    { label: "Bandeira", value: "" },
    { label: "Visa", value: "004" },
    { label: "Visa débito", value: "026" },
    { label: "Mastercard", value: "003" },
    { label: "Mastercard débito", value: "025" },
    { label: "Elo", value: "008" },
    { label: "Elo débito", value: "027" },
    { label: "Amex", value: "006" },
    { label: "Hipercard", value: "021" },
  ];

  useEffect(() => {
    getSettlementReceivables(getInitialValues());
  }, []);

  return (
    <Container style={{ padding: "0px" }}>
      <Row>
        <Label>Filtrar por:</Label>
      </Row>

      <Formik
        initialValues={getInitialValues()}
        onSubmit={async (values: any) => {
          await getSettlementReceivables(values);
        }}
      >
        {({ setFieldValue, values }) => (
          <Form>
            <Row gutter={16}>
              <Col>
                <input
                  type="date"
                  onChange={(e) => handleChangeInitialDate(e, setFieldValue)}
                  name="rangeStartReceiveDate"
                  placeholder="Data Inicial"
                  step="1"
                />
              </Col>

              <Col>
                <input
                  type="date"
                  onChange={(e) => handleChangeEndDate(e, setFieldValue)}
                  name="rangeEndReceiveDate"
                  placeholder="Data Final"
                  step="1"
                />
              </Col>

              <Col>
                <Field
                  type="text"
                  name="merchantId"
                  placeholder="Cód. Lojista"
                />
              </Col>

              <Col>
                <Field
                  type="text"
                  name="paymentIdentifier"
                  placeholder="Identificador Pagamento"
                />
              </Col>

              <Col>
                <Select
                  defaultValue={paymentTypeFieldValue}
                  style={{width:'100%'}}
                  onChange={(value) => {
                    setFieldValue("paymentType", value);
                    setPaymentTypeFieldValue(value);
                    }}
                  options={paymentOptions}
                />
              </Col>

              <Col>
                <Select
                  defaultValue={statusTypeFieldValue}
                  style={{width:'100%'}}
                  onChange={(value) => {
                    setFieldValue("operationStatus", value);
                    setStatusPaymentTypeFieldValue(value);
                    }}
                  options={statusOptions}
                />
              </Col>

              <Col>
                <Select
                  defaultValue={brandCodeFieldValue}
                  style={{width:'100%'}}
                  onChange={(value) => {
                    setFieldValue("brandCode", value);
                    setBrandCodeFieldValue(value);
                    }}
                  options={brandCodeOptions}
                />
              </Col>

              <Col>
                <Select
                  value={receiverTypeFieldValue}
                  style={{ width: "100%" }}
                  onChange={(value: number | null) => {
                    setFieldValue("receiverType", value);
                    setReceiverTypeFieldValue(value);
                  }}
                  options={receiverTypeOptions}
                />
              </Col>

              <Col>
                <Select
                  value={sftpEnabledFieldValue}
                  style={{ width: "100%" }}
                  onChange={(value: boolean | null) => {
                    setFieldValue("sftpEnabled", value);
                    setSftpEnabledFieldValue(value);
                  }}
                  options={sftpEnabledOptions}
                />
              </Col>

              <Col>
                <Button htmlType="submit">Consultar</Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </Container>
  );
};
